module.exports = __webpack_public_path__ + "img/gidravlicheskij-i-silovoj-instrument.2a2f25da.svg";